import TurbolinksAdapter from 'vue-turbolinks'
import Vue from 'vue/dist/vue.esm'
import App from '../app.vue'
import SearchForm from '../searchForm.vue'
import StationSelection from '../stationSelection.vue'
import ShipmentContainer from '../shipmentContainer.vue'
import RatesModal from '../ratesModal.vue'
import ReturnRatesModal from '../returnRatesModal.vue'
import LoadingReturnRatesModal from '../loadingReturnRatesModal.vue'
import TestResponseModal from '../testResponseModal.vue'
import ShipmentItem from '../shipmentItem.vue'
import SaveStateModal from '../saveStateModal.vue'
import CarrierInfo from '../carrierInfo.vue'
import ShipmentAddressDisplay from '../shipmentAddressDisplay.vue'
import ConsolidatedOrders from '../consolidatedOrders.vue'
import VueDatepickerLocal from 'vue-datepicker-local'
import International from '../international.vue'
import ShipmentInfoModal from '../shipmentInfoModal.vue'
import LoadShipmentModal from '../loadShipmentModal.vue'
import Errors from '../errors.vue'
import axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCircleNotch)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(TurbolinksAdapter);
Vue.prototype.$http = axios;

Vue.component('app', App);
Vue.component('international', International);
Vue.component('errors', Errors);
Vue.component('search', SearchForm);
Vue.component('station', StationSelection);
Vue.component('shipmentContainer', ShipmentContainer)
Vue.component('shipmentItem', ShipmentItem)
Vue.component('carrierInfo', CarrierInfo)
Vue.component('saveStateModal', SaveStateModal)
Vue.component('shipmentAddressDisplay', ShipmentAddressDisplay)
Vue.component('ratesModal', RatesModal)
Vue.component('returnRatesModal', ReturnRatesModal)
Vue.component('loadingReturnRatesModal', LoadingReturnRatesModal)
Vue.component('testResponseModal', TestResponseModal)
Vue.component('shipmentInfoModal', ShipmentInfoModal)
Vue.component('loadShipmentModal', LoadShipmentModal)
Vue.component('consolidatedOrders', ConsolidatedOrders)
Vue.component('date-picker', VueDatepickerLocal)

if (window.location.pathname === "/integrated_shipments") {
  $(document).on('ready turbolinks:load', () => {
    const app = new Vue({
      el: '[data-behavior="vue"]'
    })
  })
}
